// extracted by mini-css-extract-plugin
module.exports = {"goalsContainer":"Goals_goalsContainer__37xjK","title":"Goals_title__3JDRo","footer":"Goals_footer__17xsZ","item":"Goals_item__2owQd"};